import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
//import GameSelector from "./Screens/Landing/GameSelector";
//import Destiny from "./Screens/Destiny/Destiny";
import Home from "./Screens/Landing/Home";
import Project from './Screens/Projects/Projects';
import ScrollToTop from './ScrollToTop';

const RoutesList = () => {

    return(
        <Router>
            < ScrollToTop />
            <Routes>
                <Route exact path='/'  element={<Home />}/>
                <Route exact path='/projects' element={<Project />} />
            </Routes>
      </Router>
    );
}

export default RoutesList; 